module.exports = __webpack_public_path__ + "static/media/panis_15.1c717378.jpg";